<template>
  <div class="d-flex flex-wrap justify-start align-center">
    <v-chip
      v-for="(item, i) in filters"
      :key="i"
      class="mx-1"
      color="primary"
      style="background-color: white !important"
      @click:close="removeFilter(item, i)"
      small
      close
      outlined
      >{{ getDisplayText(item.text) }}</v-chip
    >
  </div>
</template>

<script>
import { getCategoryDisplayName } from "@/commons/util.js";
export default {
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    removeFilter(item, i) {
      this.$emit("removeFilter", item, i);
    },
    getDisplayText(text) {
      return getCategoryDisplayName(text);
    },
  },
};
</script>
